<template>
    <div>
        <div v-if="item.enable&&item.text&&!draftPeople.enable"
             :style="{'font-family':item.font,
             'font-size':item.fontSize,
             'text-align':item.bottom?'right':'center',
             'margin-top':item.bottom?'2mm':'0px',
             'margin-bottom':item.bottom?'0mm':'3mm'}">
            {{item.text}}
        </div>
        <!--发文字号（带签发人）-->
        <div v-if="item.enable&&item.text&&draftPeople.enable&&draftPeople.text"
             style="display: flex;flex-direction: row;justify-content: space-between;margin-bottom: 4mm;margin-top: 11.08mm;">
            <div :style="{'font-family':item.font,'font-size':item.fontSize}">
                {{item.text}}
            </div>
            <div style="font-family: 仿宋_GB2312;font-size: 16pt;">签发人：
                <span :style="{'font-family':draftPeople.font,'font-size':draftPeople.fontSize}">
                                    {{draftPeople.text}}
                                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DocCode",
        props: {
            item: {
                enable: false,
                text: null,
                bold: null,
                font: null,
                scale: null,
                fontSize: null,
                align: null,
                bottom:false
            },
            draftPeople: {
                enable: false,
                type: null,
                text: null,
                font: null,
                fontSize: null,
                align: null,
                scale: null
            }
        }
    }
</script>